import EmbeddedContentModel from './embedded-content-model'
import _ from 'lodash'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import ConfigUrl from './config-url'

export default function (bootslideMenu) {
	var label = 'dashboards.embedded'
	return {
		label: i18n.get(label),
		content: option('add-widget-embedded-content', label),
		target: _.bind(function (e) {
			// Create the widget model, but don't add it to the canvas until
			// the user has completed the URL form
			let widget = new EmbeddedContentModel({
				properties: {
					type: 'embedded-content'
				}
			})

			let view = new ConfigUrl({
				model: widget,
				dialogTitle: 'dashboards.embeddedContent.add'
			})

			view.on('done', () => {
				createWob(bootslideMenu.canvas, widget, { fetchData: false }, bootslideMenu)
			})

			appDisplay.dialog(view)

			e.preventDefault()
			e.stopPropagation()

			this.trigger('done')
		}, bootslideMenu)
	}
}
